import "./styles/modalSuccesful.css";
import Checked from '../../../static/checked.png';
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

export function ModalSuccess({ showModal = false }) {
  const [show, setShow] = useState(showModal);

  useEffect(() => {
    if (showModal) {
      setShow(showModal);
    }
  }, [showModal]);

  function handleClose() {
    setShow(false);
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        contentClassName="ms-modal-custom font-family"
      >
        {/* 
        Button to close modal 
         <div className="ms-buttonClose">
          <button
            type="button"
            onClick={handleClose}
            class="btn-close"
            aria-label="Close"
          ></button>
        </div> */}
        <Modal.Body>
          <div style={{ textAlign: "-webkit-center" }}>
            <div className="ms-main-header">
              <h1>Thank you !</h1>
            </div>
            <div className="">
              <img
                src="https://site-files-new.s3.amazonaws.com/FiftyFlowers/react/testimonials/Static+Media+Files/success.png"
                alt="WeddingSuccessFlowers"
                className="ms-roundedImage"
              />
            </div>
            <div className="ms-subheader">
              <h4><b>Your Story has been Submitted <br /> Now Share!</b></h4>
            </div>
            <div className="ms-mainText-content">
              <ul className="ms-list">
                <li><img src={Checked} alt="" style={{width: '22px',height: '22px'}}/> Post a photo of your wedding flowers on your Insta</li>
                <li><img src={Checked} alt="" style={{width: '22px',height: '22px'}}/> Tag @FiftyFlowers In your photo</li>
                <li><img src={Checked} alt="" style={{width: '22px',height: '22px'}}/> Use #FiftyFlowers and #WinYourWeddingFlowers in your post.</li>
              </ul>
            </div>

            <div className="ms-SocialNetworks">

              <div className="ms-social-icons">
                <a
                  href="https://www.instagram.com/fiftyflowers/"
                  className="wywf--social-option"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://site-files-new.s3.amazonaws.com/FiftyFlowers/react/testimonials/Static+Media+Files/social/inst-icn.svg"
                    className="ms-social-instagram"
                    alt="Instagram"
                  />
                </a>
              </div>
              
            </div>
            <div className="ms-mainAdvice">
              <p>
              Winners will be announced by January 15, 2023.
              </p>
            </div>
            <br />
            <a
              href="/"
              className="btn btn--primary product-form__cart-submit roundedBtn ms-aButton"
            >
              Continue Shopping
            </a>
          </div>
          <br />
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ModalSuccess;
